import { GET_HELPDESK_TICKETS } from '../constants/helpdeskTicketsList';

const initialState = {
  tickets: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_HELPDESK_TICKETS:
      return {
        ...state,
        tickets: action.payload,
      };
    default:
      return state;
  }
};
